import React, { Component, Fragment } from 'react';
import { translate } from '../Services/translation';

class Cart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editingQuantity: {},
            removingRow: {},
        };
    }

    onQuantityChange(rowSystemId, quantity) {
        this.setState(previousState => ({
            ...previousState,
            editingQuantity: {
                ...previousState.editingQuantity,
                [rowSystemId]: quantity,
            },
        }));
    }

    handleUpdateClick(rowSystemId, currentQuantity, newQuantity) {
        if (currentQuantity == newQuantity) {
            return;
        }
        this.props.updateOrderRowQuantity(rowSystemId, newQuantity);
    }

    render() {
        const { editingQuantity, removingRow } = this.state;
        const isCasallB2B = document.body.classList.contains('casall-sport');
        const isCasallPro = document.body.classList.contains('casall-pro');

        return (
            <div className="row checkout__container">
                <div className="columns simple-table">
                    {this.props.orderRows &&
                        this.props.orderRows.map(order => (
                            <div
                                className="checkout-cart__row"
                                key={order.rowSystemId}
                            >
                                <div className="checkout-cart__image-wrapper">
                                    <img
                                        className="checkout-cart__image "
                                        src={order.image}
                                        alt={order.name}
                                    />
                                </div>
                                <div className="cart-row-content">
                                    <div className="checkout-cart__image-info">
                                        <a href={order.url}>{order.name}</a>
                                    </div>
                                    {isCasallPro &&
                                    (order.isQuotation ||
                                        !this.props.isAuthenticated) ? (
                                        translate('product.quotation')
                                    ) : (
                                        <div>
                                            {isCasallB2B ? (
                                                <div className="item-price-holder simple-table__cell--no-break-word">
                                                    {order.campaignPrice ? (
                                                        <Fragment>
                                                            <div className="checkout-cart__campaign-price">
                                                                {
                                                                    order.campaignPrice
                                                                }
                                                            </div>
                                                            <div className="checkout-cart__original-price">
                                                                {order.price}
                                                            </div>
                                                        </Fragment>
                                                    ) : (
                                                        <Fragment>
                                                            {order.price}
                                                        </Fragment>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className="product__price-container">
                                                    <div className="product__price-column">
                                                        <div className="item-price-holder simple-table__cell--no-break-word">
                                                            {order.campaignPrice ? (
                                                                <Fragment>
                                                                    {this.props
                                                                        .abovePriceText && (
                                                                        <div className="product__price-subtext">
                                                                            {
                                                                                this
                                                                                    .props
                                                                                    .abovePriceText
                                                                            }
                                                                        </div>
                                                                    )}
                                                                    <div
                                                                        className="product__campaign-price 
                                                                        "
                                                                    >
                                                                        {
                                                                            order.campaignPrice
                                                                        }
                                                                    </div>
                                                                    {order.belowPriceText && (
                                                                        <div className="product__price-subtext">
                                                                            {
                                                                                order.belowPriceText
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </Fragment>
                                                            ) : (
                                                                <div className="price">
                                                                    {
                                                                        order.price
                                                                    }
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    {/*
                              TODO:
                              Below (ex: sizes and colors) needs to be printed with dynamic values ONLY if they are set.
                              There might be more attributes that needs to be taken into consideration.
                              For example shape, weight or form so it needs to get all attributes and print em one after one.
                              */}
                                    <div className="attributes-wrapper">
                                        {order.size != undefined ? (
                                            <div className="size-holder">
                                                {translate('product.size')}:{' '}
                                                {order.size}
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                        {order.color != undefined ? (
                                            <div className="size-holder">
                                                {translate('product.color')}:{' '}
                                                {order.color}
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                    <div className="cart-quantity-wrapper">
                                        {!order.isFeeRow &&
                                        !order.isServiceRow ? (
                                            <>
                                                <div
                                                    className="quantity-input-row"
                                                    key={order.rowSystemId}
                                                >
                                                    <div className="checkout-cart-row-quantity">
                                                        <button
                                                            type="button"
                                                            className="minus-cart-quantity"
                                                            onClick={event =>
                                                                this.handleUpdateClick(
                                                                    order.rowSystemId,
                                                                    order.quantity--,
                                                                    editingQuantity[
                                                                        order
                                                                            .rowSystemId
                                                                    ] ||
                                                                        order.quantity--,
                                                                )
                                                            }
                                                        >
                                                            -
                                                        </button>
                                                        {order.isFreeGift ? (
                                                            <div>
                                                                {' '}
                                                                {
                                                                    order.quantity
                                                                }{' '}
                                                            </div>
                                                        ) : (
                                                            <div className="input-holder">
                                                                <input
                                                                    className="checkout-cart__input"
                                                                    type="numeric"
                                                                    min="1"
                                                                    max="100"
                                                                    maxLength={
                                                                        3
                                                                    }
                                                                    disabled
                                                                    value={
                                                                        editingQuantity[
                                                                            order
                                                                                .rowSystemId
                                                                        ] ||
                                                                        order.quantity
                                                                    }
                                                                    onChange={event =>
                                                                        this.onQuantityChange(
                                                                            order.rowSystemId,
                                                                            event
                                                                                .target
                                                                                .value,
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        )}
                                                        <button
                                                            type="button"
                                                            className="plus-cart-quantity"
                                                            onClick={event =>
                                                                this.handleUpdateClick(
                                                                    order.rowSystemId,
                                                                    order.quantity++,
                                                                    editingQuantity[
                                                                        order
                                                                            .rowSystemId
                                                                    ] ||
                                                                        order.quantity++,
                                                                )
                                                            }
                                                        >
                                                            +
                                                        </button>
                                                    </div>
                                                    {isCasallPro &&
                                                    this.props
                                                        .isAuthenticated &&
                                                    !order.isQuotation ? (
                                                        <div className="stockText">
                                                            ({order.stock}{' '}
                                                            {translate(
                                                                'product.stockText',
                                                            )}
                                                            )
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div
                                                    className="quantity-input-row"
                                                    key={order.rowSystemId}
                                                >
                                                    <div className="checkout-cart-row-quantity">
                                                        <button
                                                            type="button"
                                                            disabled
                                                            className="minus-cart-quantity"
                                                        />
                                                        <input
                                                            type="numeric"
                                                            disabled
                                                            className="checkout-cart__input"
                                                            value={
                                                                order.quantity
                                                            }
                                                        />

                                                        <button
                                                            type="button"
                                                            disabled
                                                            className="plus-cart-quantity"
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        {isCasallPro &&
                                        (order.isQuotation ||
                                            !this.props
                                                .isAuthenticated) ? null : (
                                            <div className="item-total-price">
                                                {order.totalPrice}
                                            </div>
                                        )}
                                    </div>
                                    <div className="remove-cart-row-wrapper">
                                        {!order.isFreeGift &&
                                            !removingRow[order.rowSystemId] && (
                                                <a
                                                    className="table__icon table__icon--delete"
                                                    onClick={() =>
                                                        this.props.removeOrderRow(
                                                            order.rowSystemId,
                                                        )
                                                    }
                                                    title={translate(
                                                        'general.remove',
                                                    )}
                                                ></a>
                                            )}
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        );
    }
}

export default Cart;
